import { gql } from "@apollo/client";

export const loadTierRules = gql`
  query LoadTierRules {
    loadTierRules {
      id
      programId
      qualificationMetric
      evaluationWindowType
      rollingWindowMonths
      immediateDowngradeEnabled
      historicalQualificationMode
      historicalQualificationMonths
      currencyCode
      currencyExponent
      status
      configVersion
      calculationVersion
      excludedSkus
      excludedProductGroups
      metricLocked
      createdAt
      createdBy
      updatedAt
      updatedBy
      reviewDateSchedule {
        type
        date
      }
      productGroupExceptionSkus {
        productGroupId
        skuIds
      }
      activationReadiness {
        ready
        problems {
          field
          errorCode
          message
        }
      }
    }
  }
`;
